import React from 'react';
import Select from 'react-select';
import TextLabel from "./TextLabel.mjs";

const G = window.glob;

class SelectPlayer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			players : ( props.players ?? G.getStatus('Players') ?? []).map( p => {
				return { value: p.id, label: p.name };
			})
		};
		this.uid = G.generateUid('SelectPlayer');
	}
	render() {
		return(
			<div className={"text-start"}>
				<Select
					autoFocus={!! this.props.autoFocus }
					className={ this.props.className || 'w-100'}
					id={ this.props.id || this.uid }
					name={ this.props.name || 'SelectPlayer' }
					defaultValue={ this.state.players.find( x => (x.value === this.props.value)) }
					options={ this.state.players }
					readOnly={ this.props.readOnly }
					placeholder={ this.props.placeholder ?? <TextLabel value={"SelectUser"} /> }
					onChange={ (o) => { this.props.onChange( o ); }}
				/>
			</div>
		)
	}
}

export default SelectPlayer;